/* eslint-disable no-unused-vars */
import React from "react";
import { object, number } from "prop-types";

import { AdContainer } from "../../ads";

import CardImage from "../../atoms/cardimage";
import StoryHeader from "../story-header";
import StorySideBar from "../story-sidebar";

import "./cartoon.m.css";
import StorySeparator from "../../atoms/story-separator";
import StoryElements from "../story-elements";
import useDevice from "../../helper/custom-hook/useDevice";
import useAdType from "../../helper/custom-hook/useAdType";

const CartoonStoryTemplate = ({ story, index }) => {
  const adType = useAdType();
  const isMobile = useDevice();
  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} showHeroImage={false} />
            <CardImage
              story={story}
              aspectRatio={[9, 16]}
              imageType={"image9x16"}
              widths={[400, 900]}
              imgParams={{ auto: ["format", "compress"], fmt: "webp", q: 50 }}
              sizes="(max-width: 1024px) 25vw, 100vw"
            />
            <StoryElements story={story} cards={story.cards.slice(1)} index={index} />
            {/* <div styleName="ad-wrapper" className="hide-desktop">
              <AdContainer
                AdClassName="standard-336x280"
                id={adType === "izooto" ? "div-gpt-ad-1711631114518-0" : "div-gpt-ad-1675837489260-0"}
                mobile={adType === "izooto" ? "PV_MWeb_AP_Top_ym" : "PV_MWeb_AP_Top"}
                isExternalAdPath={adType === "izooto" ? true : false}
              />
            </div> */}
            {/* <div styleName="ad-wrapper" className="hide-mobile">
              <AdContainer
                AdClassName="standard-970x90"
                id={adType === "izooto" ? "div-gpt-ad-1711630948244-0" : "div-gpt-ad-1675837241937-0"}
                desktop={adType === "izooto" ? "PV_Desktop_AP_LB_Bottom_ym" : "PV_Desktop_AP_Leaderboard_Bottom"}
                isExternalAdPath={adType === "izooto" ? true : false}
              />
            </div> */}
          </div>
        </div>
        {!isMobile && (
          <div className="side-story-section ">
            <StorySideBar index={index} story={story} />
          </div>
        )}
      </div>
    </>
  );
};

CartoonStoryTemplate.propTypes = {
  story: object,
  index: number
};

const CartoonStory = (props) => {
  return <CartoonStoryTemplate story={props.story} index={props.index} />;
};

CartoonStory.propTypes = {
  story: object,
  index: number
};

export default CartoonStory;
